import React, { useState } from "react";
import { API, graphqlOperation } from "aws-amplify";
import { getFeedbackCategory } from "../../../../graphql/queries";
import { updateFeedbackCategory } from "../../../../graphql/mutations";
import SimpleCreateEdit from "../../../Common/Crud/SimpleCreateEdit";
import TextInput from "../../../../components/Common/TextInput";
import * as FeedbackCategoriesConstants from "../../../../graphql/Constants/FeedbackCategories/Types";
import nameChangeHandler from "../../../Common/Crud/formHandlers/nameChangeHandler";
import orderChangeHandler from "../../../Common/Crud/formHandlers/orderChangeHandler";
import nameOnlyFormsValidationHandler from "../../../Common/Crud/formHandlers/nameOnlyFormsValidationHandler";
import * as CrudActionTypes from "../../../../constants/Crud/ActionTypes";

const FeedbackCategoryEdit = (props) => {
  // states
  const [name, setName] = useState("");
  const [order, setOrder] = useState(0);
  const [inputFieldsDisable, setInputFieldsDisable] = useState(false);
  const [errors, setErrors] = useState({});
  const [updateButtonDisableStatus, setUpdateButtonDisableStatus] = useState(
    false
  );

  //#region update FeedbackCategory business logic
  const handleUpdateFeedbackCategory = async () => {
    try {
      // initial required FeedbackCategory update data
      let input = {
        id: props.match.params.feedbackCategoryId,
        name: name.trim(),
        order: order
      };

      await API.graphql(graphqlOperation(updateFeedbackCategory, { input }));
      return { result: true, message: `FeedbackCategory updated successfully` };
    } catch (error) {
      return {
        result: false,
        message: `Error updating FeedbackCategory, ${JSON.stringify(error, null, 2)}`,
      };
    }
  };
  //#endregion

  return (
    <SimpleCreateEdit
      {...props}
      crudActionType={CrudActionTypes.Edit}
      returnHandler={() => props.history.push(`/FeedbackCategories`)}
      modelName="Feedback Category"
      getModelMethod={async () => {
        let result = await API.graphql(
          graphqlOperation(getFeedbackCategory, { id: props.match.params.feedbackCategoryId })
        );
        if (result) {
          setName(result.data.getFeedbackCategory.name);
          setOrder(result.data.getFeedbackCategory.order);
        }
        return result.data.getFeedbackCategory;
      }}
      // createOrUpdateDisableMethod={(modelData) => {
      //   if (modelData.id === FeedbackCategorysConstants.Other.id) return true;
      //   return false;
      // }}
      // createOrUpdateDisabledActions={() => {
      //   setNameInputTextDisable(true);
      // }}
      formSubmissionHandler={handleUpdateFeedbackCategory}
      formValidationHandler={() =>
        nameOnlyFormsValidationHandler(
          name,
          "FeedbackCategory",
          false, // we need to exclude the OTHER
          setUpdateButtonDisableStatus,
          setErrors
        )
      }
      setErrorsState={() => setErrors}
      actionButtonDisabledState={updateButtonDisableStatus}
    >
      <TextInput
        type="name"
        id="name"
        label="Feedback Category Name"
        placeholder="Enter a Feedback Category name"
        value={name}
        onChange={(e) =>
          nameChangeHandler(
            e,
            "FeedbackCategory",
            false, // we need to exclude the OTHER,
            setName,
            setUpdateButtonDisableStatus,
            setErrors
          )
        }
        isRequired={true}
        error={errors.name}
        disabled={inputFieldsDisable}
      />
      <TextInput
        type="number"
        id="order"
        label="Feedback Category Order"
        placeholder="Enter a Feedback Category Order"
        value={order}
        onChange={(e) =>
          orderChangeHandler(
            e,
            "FeedbackCategory",
            setOrder,
            setUpdateButtonDisableStatus,
            setErrors
          )
        }
        isRequired={true}
        error={errors.order}
        disabled={inputFieldsDisable}
      />
    </SimpleCreateEdit>
  );
};

export default FeedbackCategoryEdit;
